import React, { useState, useEffect} from "react";
import { useDispatch, useSelector } from "react-redux";
import Spinner from "react-bootstrap/Spinner";
import { allFeatured, getFeatured } from '../reducers/catalog';
import Product from "./Product";
import { getSubsite, getRetailSubsite } from '../reducers/auth';
import Container from 'react-bootstrap/Container';
import SubsiteService from "../services/subsite.service";
import { useParams, useSearchParams } from "react-router-dom";
import { useNavigate } from 'react-router-dom';

const BACKEND_URL = process.env.REACT_APP_LOCALHOST_URL;

const Site = () => {
    let { siteId } = useParams();
    const navigate = useNavigate();

  const dispatch = useDispatch();
  const featured = useSelector(allFeatured);
  const featuredStatus = useSelector(state => state.catalog.featuredStatus);
  const currentSubsite = useSelector(getSubsite);
  const [featuredContent, setFeaturedContent]  = useState(<Spinner text="Loading..." />);

  const [subsite, setSubsite] = useState(null);
  const [message, setMessage] = useState("");

  useEffect(() => {
    dispatch(getRetailSubsite(siteId));
  }, []);

  useEffect(() => {
    //subsite loaded
    navigate("/featured");
  }, [currentSubsite]);


  return (
    <Container>
        <div style={{padding: 30}}>
        <h3>Welcome to Shop Ignite</h3>
        <div dangerouslySetInnerHTML={{ __html: currentSubsite?.content }}></div>

      <h3>Featured Apparel</h3>
      <div class="product-container">
            { currentSubsite?.subsiteName }
      </div>
      </div>
    </Container>
  );
};
export default Site;